import { BrandColors } from '../BrandColors.type'

type VariantType = {
  normal?: {
    background: string
    color: string
    light: string
    heart?: string
    signet?: string
    text?: string
  }
  revert?: {
    background: string
    color: string
    light: string
    heart: string
    signet: string
    text?: string
  }
}

const variants: Record<BrandVariant, VariantType> = {
  black: {
    normal: {
      background: 'bg-black',
      color: 'text-blue',
      light: 'text-blue-light',
      text: 'text-white',
    },
  },
  blue: {
    normal: {
      background: 'bg-white',
      color: 'text-blue',
      light: 'text-blue-light',
    },
    revert: {
      background: 'bg-blue',
      color: 'text-white',
      light: 'text-blue-lightest',
      heart: 'text-yellow',
      signet: 'monochrome',
      text: 'text-white',
    },
  },
  yellow: {
    revert: {
      background: 'bg-yellow',
      color: 'text-white',
      light: 'text-yellow-lightest',
      heart: 'text-blue',
      signet: 'monochrome',
    },
  },
  green: {
    revert: {
      background: 'bg-green',
      color: 'text-white',
      light: 'text-green-lightest',
      heart: 'text-pink',
      signet: 'monochrome',
      text: 'text-white',
    },
  },
  pink: {
    revert: {
      background: 'bg-pink',
      color: 'text-white',
      light: 'text-pink-lightest',
      heart: 'text-green',
      signet: 'monochrome',
      text: 'text-white',
    },
  },
}

type BrandVariant = 'black' | 'blue' | 'yellow' | 'green' | 'pink'
export type MozgotekaClassesProps = {
  variant?: BrandVariant
  revert?: boolean
}

const useMozgotekaClasses = (props: MozgotekaClassesProps | undefined) => {
  const { variant = 'blue', revert = false } = props ?? {}
  const result =
    variants[variant][revert ? 'revert' : 'normal'] ??
    Object.values(variants[variant])[0]
  if (!result) {
    throw new Error(
      `Unknown variant: ${variant}, revert: ${JSON.stringify(revert)}`
    )
  }
  return {
    heart: 'text-blue',
    signet: 'color',
    text: 'text-black',
    ...result,
  } as BrandColors
}

export default useMozgotekaClasses
